import PlusIcon from "../../assets/icons/PlusIcon";
import SearchIcon from "../../assets/icons/SearchIcon";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { addProductToCart, clearProductInCart, removeProductInCart, updateQuantityProductInCart } from "../../store/slices/cartSlice";
import { useEffect, useRef, useState } from "react";
import { getCartState, getCategoryState, getComboState, getProductState, getUiState } from "../../store";
import MenuIcon from "../../assets/icons/MenuIcon";
import { disableScrollScreen, showComboDetailModal, showProductDetailModal, showSidebarModal } from "../../store/slices/uiSlice";
import { IProduct } from "../../types/product";
import { productPrvSliceActions, setProductDetail } from "../../store/slices/productSlice";
import EmptySearchResult from "../../assets/icons/EmptySearchResult";
import ModalProductDetail from "../modals/ModalProductDetail";
import MinusIcon from "../../assets/icons/MinusIcon";
import CheckIcon from "../../assets/icons/CheckIcon";
import { comboPrvSliceActions, setComboSelected } from "../../store/slices/comboSlice";
import { ICombo } from "../../types/combo";
import { formatProductInCart, getProductUnitPriceByQuantity } from "../../helpers/handleProduct";
import ModalComboDetail from "../modals/ModalComboDetail";
import LoadingSpinner from '../layouts/common/Loading';
export default function MainContent() {
    const { cartInfo } = useAppSelector(getCartState);
    const { categoryId, categoryName } = useAppSelector(getCategoryState);
    const { productStore } = useAppSelector(getProductState);
    const { productDetail } = useAppSelector(getProductState);
    const { comboSelected, comboStore } = useAppSelector(getComboState);
    const { isShowProductDetail, isShowComboDetail } = useAppSelector(getUiState);
    const timeoutRef = useRef<any>(null);
    const [products, setProducts] = useState<IProduct[]>();
    const [combos, setCombos] = useState<ICombo[]>();
    const [isEmptySearchResult, setIsEmptySearchResult] = useState<boolean>(false);
    const [isEmptyCategoryResult, setIsEmptyCategoryResult] = useState<boolean>(false);
     const [isLoading, setIsLoading] = useState<boolean>(true); // 👈 thêm state loading
    const dispatch = useAppDispatch();
    useEffect(() => {
        const fetchProducts = async () => {
            const res = await dispatch(productPrvSliceActions.getProductList());
            setProducts(prev => prev = res.payload as IProduct[]);
        }
        const fetchCombos = async () => {
            const res = await dispatch(comboPrvSliceActions.getComboList());
            setCombos(prev => prev = res.payload as ICombo[]);
        }

        // 👈 set loading trước khi fetch
        setIsLoading(true);
        Promise.all([fetchProducts(), fetchCombos()]).finally(() => setIsLoading(false)); // 👈 tắt loading sau khi gọi xong

    }, [dispatch])
    useEffect(() => {
        setIsEmptySearchResult(prev => prev = false);
        if (!!categoryId) {
            const removeCategoryIdNull = productStore.filter(prod => !!prod.category);
            const findProductByCategoryId = removeCategoryIdNull.filter(product => {
                return product.category.some(cate => cate.category_id === categoryId)
            })
            if (findProductByCategoryId.length > 0) {
                setProducts(prev => prev = findProductByCategoryId);
                
                setIsEmptyCategoryResult(prev => prev = false);
                return;
            }
            setIsEmptyCategoryResult(prev => prev = true);
            setProducts(prev => prev = []);

        } else {
            setProducts(prev => prev = productStore);
            setCombos(prev => prev = comboStore);

        }
    }, [categoryId, productStore, comboStore])
    const handleSearchTyping = (keyword: string) => {
        setIsEmptyCategoryResult(prev => prev = false);
        if (timeoutRef) {
            timeoutRef.current = null;
            clearTimeout(timeoutRef.current);
        }
        if (!keyword) {
            setCombos(prev => prev = comboStore);
            setProducts(prev => prev = productStore);
        }
        timeoutRef.current = setTimeout(() => {
            const filterProductByKeyword = productStore.filter(product =>
                product.name.toLowerCase().includes(keyword.toLowerCase()));
            const filterComboByKeyword = comboStore.filter(combo =>
                combo.name.toLowerCase().includes(keyword.toLowerCase()));
            setCombos(prev => prev = filterComboByKeyword);
            if (filterProductByKeyword.length > 0) {
                setProducts(prev => prev = filterProductByKeyword);
                setIsEmptySearchResult(prev => prev = false);
                return;
            }
            setProducts(prev => prev = []);
            setIsEmptySearchResult(prev => prev = true);
        }, 500)
    }
    return (
        <div className="col-span-2 w-full -mt-6">
            <div className="flex items-end gap-4 sticky top-0 -mx-[20px] px-[20px] pt-6 bg-[#F4F4F4] max-md:gap-1 max-md:fixed max-md:left-0 max-md:top-0 max-md:right-0 max-md:px-2 max-md:py-3 max-md:items-center max-md:mx-0">
                <div
                    className="hidden max-md:pl-2 max-md:block max-md:px-3"
                    onClick={() => {
                        dispatch(showSidebarModal());
                        dispatch(disableScrollScreen());
                    }}
                >
                    <MenuIcon />
                </div>
                <div className="flex items-center gap-2 w-full relative">
                    <div className="absolute left-3 top-2/4 translate-y-[-50%]">
                        <SearchIcon />
                    </div>
                    <input
                        type="text"
                        className="flex-1 px-11 py-2 rounded border-[1px] border-[#d8dadc] max-md:bg-gray-200 focus:outline-[#5288FF]"
                        placeholder="Bạn cần tìm sản phẩm gì?"
                        onKeyUp={(ev) => handleSearchTyping((ev.target as HTMLInputElement).value)}
                        onBlur={() => setIsEmptyCategoryResult(prev => prev = false)}
                    />
                </div>
            </div>
            {combos && combos.length > 0 && !categoryId &&
                <div className="mt-4 rounded">
                    <h2 className="px-4 py-3 text-lg text-[#182537] font-medium bg-[#e5ebeb]">Combo ưu đãi ({combos.length})</h2>
                    <div className="flex flex-col gap-8 p-4 max-md:p-2 bg-white">
                        {combos.map(combo => {
                            const comboInCart = cartInfo.find(item => item.id === combo.id);
                            const quantity = comboInCart ? +comboInCart.quantity : 1;
                            return (
                                <div key={combo.id} className="flex justify-center gap-4">
                                    <button className="flex justify-center items-start"
                                        onClick={() => {
                                            dispatch(setComboSelected(combo));
                                            dispatch(showComboDetailModal());
                                            dispatch(disableScrollScreen());
                                        }}
                                    >
                                        <img
                                            src={combo.image ? combo.image : "http://static.salekit.com/public/images/no-image.png"}
                                            alt="Ảnh"
                                            className="w-20 h-auto"
                                        />
                                    </button>
                                    <div className="w-full">
                                        <h1 className="text-[#182537] text-base font-medium break-words cursor-pointer w-full"
                                            onClick={() => {
                                                dispatch(setComboSelected(combo));
                                                dispatch(showComboDetailModal());
                                                dispatch(disableScrollScreen());
                                            }}
                                        >
                                            {combo.name}
                                        </h1>
                                        <div className="flex items-end justify-between mt-2">
                                            <div className="flex items-center gap-2"
                                                onClick={() => {
                                                    dispatch(setComboSelected(combo));
                                                    dispatch(showComboDetailModal());
                                                    dispatch(disableScrollScreen());
                                                }}
                                            >
                                                <p className="text-[#46515F] text-base font-normal cursor-pointer">
                                                    {(+combo.price_sale).toLocaleString("vi-VN")}
                                                </p>
                                                {+combo.combo_price > 0
                                                    && +combo.combo_price !== +combo.price_sale
                                                    && <p className="line-through text-sm font-normal cursor-pointer"
                                                        style={{ color: "rgba(70, 81, 95, 0.5)" }}
                                                    >
                                                        {(+combo.combo_price).toLocaleString("vi-VN")}
                                                    </p>
                                                }
                                            </div>
                                            {comboInCart ? <div className="flex items-center gap-2">
                                                <button
                                                    onClick={() => {
                                                        dispatch(removeProductInCart(combo.id));
                                                    }}
                                                >
                                                    <MinusIcon />
                                                </button>
                                                <input
                                                    type="text"
                                                    className="outline-none w-10 flex-1 text-center border-b-2 border-b-[#F4F1F1] border-solid"
                                                    value={quantity}
                                                    onChange={(ev) => {
                                                        const value = +ev.target.value;
                                                        dispatch(updateQuantityProductInCart({
                                                            id: combo.id, quantity: value
                                                        }));
                                                    }}
                                                    onBlur={() => {
                                                        if (!quantity) {
                                                            dispatch(clearProductInCart({ id: combo.id }));
                                                        }
                                                    }}
                                                />
                                                <button
                                                    onClick={() => {
                                                        dispatch(addProductToCart(formatProductInCart(combo, "combo")));
                                                    }}
                                                >
                                                    <PlusIcon />
                                                </button>
                                            </div>
                                                : <button onClick={() => {
                                                    dispatch(addProductToCart(formatProductInCart(combo, "combo")));
                                                }}>
                                                    <PlusIcon />
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        )}
                    </div>
                </div>
            }

            <div className="bg-white rounded mt-4 shadow-md">
                {isLoading ? (
                    <div className="flex justify-center items-center p-6">
                        <LoadingSpinner /> {/* cái spinner bạn import sẵn */}
                    </div>
                ) : (
                <>
                <h2 className="px-4 py-3 text-lg text-[#182537] font-medium bg-[#e5ebeb]">{categoryName || "Tất cả sản phẩm"} ({products?.length})</h2>
                {isEmptySearchResult && !!!products?.length && (
                    <div className="flex flex-col items-center justify-center pb-4 gap-4 bg-inherit">
                        <EmptySearchResult />
                        <p className="text-sm text-[#7A8086] font-normal">
                            Không tìm thấy sản phẩm nào với từ khoá trên!
                        </p>
                    </div>
                )}
                {isEmptyCategoryResult && !!!products?.length && (
                    <div className="flex flex-col items-center justify-center pb-4 gap-4 bg-inherit">
                        <EmptySearchResult />
                        <p className="text-sm text-[#7A8086] font-normal">
                            Không tìm thấy sản phẩm nào với danh mục này!
                        </p>
                    </div>
                )}
                <div className="p-4 flex flex-col gap-8 max-md:p-2">
                    {!!products?.length && products?.map((product: IProduct, index: number) => {
                        
                        const productInCart = cartInfo.find(item => item.id === product.id);
                        const productChildInCart = cartInfo.find(item => item.parent_id === product.id);
                        const quantity = productInCart ? +productInCart.quantity : 1;
                        const wholesaleUnitPrice = getProductUnitPriceByQuantity(product, quantity);
                        const showWholesalePrice = product.wholesale_upto > 0 && wholesaleUnitPrice < Number(product.price_sale);
                        return (
                            <div key={index} className="flex justify-center gap-4">
                                <button className="flex justify-center items-start"
                                    onClick={() => {
                                        dispatch(showProductDetailModal());
                                        dispatch(disableScrollScreen());
                                        dispatch(setProductDetail(product));
                                    }}
                                >
                                    <img src={product.photos && product.photos.length > 0
                                        ? product.photos[0]
                                        : "http://static.salekit.com/public/images/no-image.png"} alt="Ảnh" className="w-20 h-auto" />
                                </button>
                                <div className="w-full">
                                    <h1 className="text-[#182537] text-base font-medium break-words cursor-pointer w-full"
                                        onClick={() => {
                                            dispatch(showProductDetailModal());
                                            dispatch(disableScrollScreen());
                                            dispatch(setProductDetail(product));
                                        }}
                                    >
                                        {product.name}
                                    </h1>
                                    <div className="flex items-end justify-between items-center mt-2">
                                        <div
                                            className="flex flex-col md:flex-row md:items-center gap-2"
                                            onClick={() => {
                                                dispatch(showProductDetailModal());
                                                dispatch(disableScrollScreen());
                                                dispatch(setProductDetail(product));
                                            }}
                                        >    
                                            <div className="flex items-center gap-2">
                                                <p className="text-[#46515F] text-base font-normal cursor-pointer ">
                                                    {(showWholesalePrice ? wholesaleUnitPrice : Number(product.price_sale)).toLocaleString("vi-VN")}
                                                </p>
                                                {showWholesalePrice ? (
                                                    <p className="line-through text-sm font-normal cursor-pointer"
                                                        style={{ color: "rgba(70, 81, 95, 0.5)" }}
                                                    >
                                                        {Number(product.price_sale).toLocaleString("vi-VN")}
                                                    </p>
                                                ) : (
                                                    +product.unit_price > 0
                                                    && +product.unit_price !== +product.price_sale
                                                    && <p className="line-through text-sm font-normal cursor-pointer"
                                                        style={{ color: "rgba(70, 81, 95, 0.5)" }}
                                                    >
                                                        {Number(product.unit_price).toLocaleString("vi-VN")}
                                                    </p>
                                                )}
                                                </div>
                                                {product.wholesale_upto > 0 && product.wholesale_price?.length > 1 && (
                                                    <p className="text-[red] text-base font-normal cursor-pointer ">
                                                        Chiết khấu tới {Number(product.wholesale_upto).toLocaleString("vi-VN")}%
                                                    </p>
                                                )}
                                        </div>
                                        {productInCart && <div className="flex items-center gap-2">
                                            <button
                                                onClick={() => {
                                                    dispatch(removeProductInCart(product.id));
                                                }}
                                            >
                                                <MinusIcon />
                                            </button>
                                            <input
                                                type="text"
                                                className="outline-none w-10 flex-1 text-center border-b-2 border-b-[#F4F1F1] border-solid"
                                                value={quantity}
                                                onChange={(ev) => {
                                                    const value = +ev.target.value;
                                                    dispatch(updateQuantityProductInCart({
                                                        id: product.id, quantity: value
                                                    }));
                                                }}
                                                onBlur={() => {
                                                    if (!quantity) {
                                                        dispatch(clearProductInCart(product));
                                                    }
                                                }}
                                            />
                                            <button
                                                onClick={() => {
                                                    dispatch(addProductToCart(formatProductInCart(product, "product")));
                                                }}
                                            >
                                                <PlusIcon />
                                            </button>
                                        </div>
                                        }
                                        {productChildInCart && <div className="flex items-center gap-2"><CheckIcon /></div>}
                                        {!productInCart && !productChildInCart && <button onClick={() => {
                                            if (product.has_child) {
                                                dispatch(setProductDetail(product));
                                                dispatch(showProductDetailModal());
                                                dispatch(disableScrollScreen());
                                                return;
                                            }
                                            dispatch(addProductToCart(formatProductInCart(product, "product")));
                                        }}>
                                            <PlusIcon />
                                        </button>}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                {isShowProductDetail && <ModalProductDetail product={productDetail} />}
                {isShowComboDetail && <ModalComboDetail combo={comboSelected} />}
                </>
                )}
            </div>
        </div >
    )
}